import { render, staticRenderFns } from "./order-forms.vue?vue&type=template&id=096f0779"
import script from "./order-forms.vue?vue&type=script&lang=js"
export * from "./order-forms.vue?vue&type=script&lang=js"
import style0 from "./order-forms.vue?vue&type=style&index=0&id=096f0779&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports